import { useQuery } from '@tanstack/react-query';
import { configApi } from '../../configApi';
import { isValidUUID } from '../../../utils/functions';

export interface IPreliminaryResult {
  notes: Note[];
  classifications: { final: Classifications; preliminary: Classifications };
  step: string;
  is_cultural_house: boolean;
  status_heteroidentification_result: string;
  invited_for_heteroidentification_test: boolean;
  status_pcd_test_result: string;
  invited_for_pcd_test: boolean;
  sub_judice: boolean;
}

interface Note {
  name: string;
  value: number;
}

interface Classifications {
  general: IClass;
  pcd: IClass;
  black_or_brown: IClass;
  extensive_competition: IClass;
}

interface IClass {
  classification: string;
  status: string;
}

const preliminaryResult = async (registration_id: string) => {
  if (!isValidUUID(registration_id)) return;

  const response = await configApi.get<IPreliminaryResult>(`candidate-area/results/${registration_id}/`);
  return response.data;
};

export const usePreliminaryResult = (registration_id: string) => {
  return useQuery({
    queryKey: ['preliminary_result', registration_id],
    queryFn: () => preliminaryResult(registration_id),
    refetchOnWindowFocus: false,
  });
};
